var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10.834,
    height: 10.745,
    viewBox: "0 0 10.834 10.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.312,
    x2: 0.792,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bde74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28b833"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3VDWHd",
    "data-name": "3VDWHd",
    transform: "translate(-126.38 -351.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(126.38 351.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M127.04,359.108a1.945,1.945,0,0,1,.164-.51,2.924,2.924,0,0,0,.1-.279.465.465,0,0,0-.208-.619c-.178-.136-.375-.245-.546-.391a.392.392,0,0,1-.052-.612,3.78,3.78,0,0,1,.43-.414.516.516,0,0,0,.154-.76,5.816,5.816,0,0,1-.312-.578.372.372,0,0,1,.248-.563c.192-.07.39-.122.583-.187.348-.117.426-.224.419-.591,0-.209-.028-.418-.028-.626,0-.333.18-.483.509-.438l.651.089a.438.438,0,0,0,.5-.26c.107-.225.191-.46.3-.684a.38.38,0,0,1,.623-.177c.208.126.41.263.614.4a.429.429,0,0,0,.515-.029c.179-.121.311-.295.483-.423a1.9,1.9,0,0,1,.168-.124.351.351,0,0,1,.529.109c.124.18.23.373.343.561.188.313.307.368.666.282.184-.044.362-.111.546-.155.393-.093.583.056.611.462a6.08,6.08,0,0,0,.061.653.418.418,0,0,0,.352.357c.18.04.362.066.544.093.523.08.631.261.449.755-.062.168-.136.333-.188.5a.442.442,0,0,0,.2.582c.175.132.36.25.532.385a.392.392,0,0,1,.053.66,4.42,4.42,0,0,1-.379.36.54.54,0,0,0-.163.808c.09.172.2.335.28.511.145.314.066.5-.26.619-.2.073-.409.126-.611.2a.44.44,0,0,0-.359.512c0,.224.028.447.028.671,0,.351-.174.5-.526.447l-.606-.085a.467.467,0,0,0-.54.277c-.1.194-.166.406-.253.606-.151.346-.369.421-.689.224-.169-.1-.328-.226-.5-.334a.467.467,0,0,0-.666.028c-.151.121-.29.258-.433.389-.313.285-.541.253-.761-.108-.1-.162-.191-.327-.288-.489a.47.47,0,0,0-.615-.254c-.233.054-.452.157-.691.19-.268.038-.413-.052-.463-.318a4.505,4.505,0,0,1-.06-.593c-.021-.413-.131-.545-.541-.623a3.932,3.932,0,0,1-.688-.134A.338.338,0,0,1,127.04,359.108Zm3.948-.448a1.013,1.013,0,0,0,.187-.155l2.124-2.122c.43-.429.859-.86,1.29-1.287.066-.065.078-.122.01-.19l-.5-.495c-.066-.066-.123-.081-.2,0-.485.486-.975.967-1.461,1.452q-.665.665-1.323,1.337c-.1.1-.163.107-.266,0-.31-.324-.634-.634-.947-.955-.088-.091-.145-.087-.229,0-.156.168-.32.328-.485.486-.065.062-.068.1,0,.17q.853.848,1.7,1.7A.151.151,0,0,0,130.988,358.66Z",
    transform: "translate(-126.38 -351.253)",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCheck);
export default __webpack_public_path__ + "static/media/profile-check.464d67c013d69bd7b32ccdeba572ad54.svg";
export { ForwardRef as ReactComponent };